import request from "@/service";

//列表
export function resCategoryTree(params = {}) {
  return request({
    url: `/resource/res/category/tree`,
    method: "get",
    params
  });
}

//详情
export function resCategoryInfo(uuid) {
  return request({
    url: `/resource/res/category/info/${uuid}`,
    method: "get"
  });
}

//置顶、上移、下移
export function upAndDown(parentId, uuid, status) {
  return request({
    url: `/resource/res/category/ud/${parentId}/${uuid}/${status}`,
    method: "get"
  });
}

//删除
export function resCategoryDelete(data) {
  return request({
    url: `/resource/res/category/delete`,
    method: "delete",
    data
  });
}

//显示、隐藏
export function resCategorySH(uuid, status) {
  return request({
    url: `/resource/res/category/sh/${uuid}/${status}`,
    method: "get"
  });
}

//新增
export function resCategorySave(data) {
  return request({
    url: `/resource/res/category/save`,
    method: "post",
    data
  });
}

//编辑
export function resCategoryUpdate(data) {
  return request({
    url: `/resource/res/category/update`,
    method: "put",
    data
  });
}

//拖拽排序
export function resCategoryDrag(data) {
  return request({
    url: `/resource/res/category/drag`,
    method: "put",
    data
  });
}

//主办/承办单位管理-列表
export function classOrganizerList(params = {}) {
  return request({
    url: `/study/classOrganizer/list`,
    method: "get",
    params
  });
}

//主办/承办单位管理-新增
export function classOrganizerSave(data) {
  return request({
    url: `/study/classOrganizer/save`,
    method: "post",
    data
  });
}

//主办/承办单位管理-拖拽
export function classOrganizerDrag(params = {}) {
  return request({
    url: `/study/classOrganizer/drag`,
    method: "get",
    params
  });
}

//主办/承办单位管理-删除
export function classOrganizerDelete(params) {
  return request({
    url: `/study/classOrganizer/delete`,
    method: "get",
    params
  });
}
//主办/承办单位管理-编辑
export function classOrganizerUpdate(data) {
  return request({
    url: `/study/classOrganizer/update`,
    method: "post",
    data
  });
}
